<template>
  <footer class="container-fluid" itemscope itemtype="http://schema.org/WPFooter">
    <div class="footer">
      <Infos />
    </div>
  </footer>
</template>

<script>

  import Infos from './Infos';

  export default {
    name: 'v-footer',
    data: () => {
      return {
      }
    },
    components: {
      Infos,
    }
  }
</script>

<style>

</style>
